var PLAY_LIST = [
        {
          title: "Rise 2",
          mp3: "//tropicalgoldseeds.com/cdn/shop/t/13/assets/546466_short_preview_1.mp3?v=85047563549597030251793746784",
        },
        {
          title: "Rise 3",
          mp3: "//tropicalgoldseeds.com/cdn/shop/t/13/assets/546526_short_preview_1.mp3?v=127516293303312915241793746784",
        },
      ];
  var TRACK_IDENTIFIER_TO_TRACK_INDEX = {
  RISE1: 0,
  RISE2: 1,
};
  var QUERY_STRING_TRACK_IDENTIFIER = "track";

      var SELECTORS = {
        jPlayer: "#jquery_jplayer_N",
        cssSelectorAncestor: "#jp_container",
      };
      var OPTIONS = {
        swfPath: "../../dist/jplayer",
        supplied: "mp3",
        useStateClassSkin: true,
        autoBlur: false,
        smoothPlayBar: true,
        keyEnabled: true,
        autoPlay: true,
      };
  
  function getInfoOfTrackToPlayFromURLOrLocalStorage() {
  //first check if user client has track info in local storage then resume from that info
  const playerInfo = localStorage.getItem("playerInfo");
  if (playerInfo) {
    var parsedPlayerInfo = JSON.parse(playerInfo);
    var trackIndex = parsedPlayerInfo.trackIndex || 0;
    var playerTimeStamp = parsedPlayerInfo.playerTimeStamp || 0;
    return {
      trackIndex,
      playerTimeStamp,
    };
  }

  // check if client has track info in query param
  var query = new URLSearchParams(window.location.search);
  if (query.has(QUERY_STRING_TRACK_IDENTIFIER)) {
    const trackIndex = query.get(QUERY_STRING_TRACK_IDENTIFIER);
    return {
      trackIndex,
      playerTimeStamp: 0,
    };
  }

  // not found any track info for user. play from 0th track.
  return {
    trackIndex: 0,
    playerTimeStamp: 0,
  };
}

     function resumePlayer() {
  var trackInfo = getInfoOfTrackToPlayFromURLOrLocalStorage();

  myPlaylist.select(trackInfo.trackIndex);
  var $jp = $(SELECTORS.jPlayer);
  $jp.on($.jPlayer.event.setmedia, function (e) {
    const resumePlayTimer = setInterval(function () {
      var isPaused = document.querySelector("audio").paused;
      if (isPaused) {
        try {
          $jp.jPlayer("play", trackInfo.playerTimeStamp);
          return;
        } catch {}
      }
      console.log("clearing player");
      clearInterval(resumePlayTimer);
    }, 1000);
  });
}

      function initializePLayer() {
        window.myPlaylist = new jPlayerPlaylist(SELECTORS, PLAY_LIST, OPTIONS);
  		resumePlayer();
  		window.setInterval(savePlayerStatusToLocalStorage, 2000);
      }

      function savePlayerStatusToLocalStorage() {
        var currentTime = $("audio")[0].currentTime;
        const trackIndex = myPlaylist.current;
        const playerInfo = {
          trackIndex: trackIndex,
          playerTimeStamp: currentTime,
        };
        localStorage.setItem("playerInfo", JSON.stringify(playerInfo));
      }

      $(document).ready(function () {
        if ($("#jp_container").length > 0) {
    		initializePLayer();
  		}
      });
